"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importStar(require("lodash"));
var react_1 = tslib_1.__importDefault(require("react"));
require("./styles.less");
var ScreenResult = function (_a) {
    var howToLink = _a.howToLink, howToText = _a.howToText, handicap = _a.handicap, par = _a.par, averageScoreUsed = _a.averageScoreUsed;
    var getTrueCourseHandicap = function (index) {
        var val = index;
        if (lodash_1.default.includes(index, '+')) {
            val = -val;
        }
        return lodash_1.parseInt(val, 10);
    };
    return (react_1.default.createElement("div", { className: 'result-screen' },
        react_1.default.createElement("div", { className: 'result-box' },
            averageScoreUsed ? 'Your Estimated Target Score is ' : 'Your Target Score is ',
            react_1.default.createElement("span", { className: 'score' }, lodash_1.parseInt(par + '', 10) + getTrueCourseHandicap(handicap))),
        howToLink && (react_1.default.createElement("div", { className: 'how-to-link' },
            react_1.default.createElement("a", { href: howToLink, target: '_blank' }, howToText)))));
};
exports.default = ScreenResult;
